import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {forkJoin, mergeMap, Observable, tap } from 'rxjs';
import { ConfigService } from './config.service';
import { CustomCertificate } from '../models/custom-certificate/custom-certificate';
import { CustomCertificateOverview } from '../models/custom-certificate/custom-certificate-overview';
import {CustomCertificatePost} from "../models/custom-certificate/custom-certificate-post";
import {PropertyServicesSummary} from "../models/property-services/property-services-summary.interface";
import {GasSafetyCertificatePost} from "../models/gas-safety-certificate/gas-safety-certificate-post";
import {GasSafetyCertificate} from "../models/gas-safety-certificate/gas-safety-certificate";
import { FileService } from './file.service';

@Injectable()
export class CustomCertificateService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private fileService: FileService
    ) {}

    getOverview(propertyReference: string): Observable<CustomCertificateOverview> {
        return this.http.get<CustomCertificateOverview>(
            `${this.configService.baseUrl}/manage/property/${propertyReference}/custom-certificates/overview`
        );
    }

    getList(propertyReference: string): Observable<CustomCertificate[]> {
        return this.http.get<CustomCertificate[]>(
            `${this.configService.baseUrl}/manage/property/${propertyReference}/custom-certificates`
        );
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<CustomCertificate>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/custom-certificates/${guid}`);
    }

    add(organisationReference: string, model: CustomCertificatePost): Observable<CustomCertificate> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<CustomCertificate>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/custom-certificates`, model))
        );
    }

    remove(propertyReference: string, item: CustomCertificate): Observable<boolean> {
        return this.http.delete<boolean>(
            `${this.configService.baseUrl}/manage/property/${propertyReference}/custom-certificates/${item.guid}`
        );
    }

    getSummary(propertyReference: string): Observable<PropertyServicesSummary> {
        return this.http.get<PropertyServicesSummary>(
            `${this.configService.baseUrl}/manage/property/${propertyReference}/custom-certificates/summary`
        );
    }
}
